import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { ButtonBar } from 'components';
import { Field } from 'formik';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex-grow: 1;
`;

export const InputRow = styled.div`
    display: flex;
    flex-direction: row;
`;

export const InputAmount = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 30%;
    margin-left: 16px;
`;
export const InputPreview = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex: 1 1 100%;
    font-size: 20px;
    margin-top: 24px;
`;

export const Label = styled.label`
    font-size: 18px;
    line-height: 1.22;
    color: ${Variables.Colors.n70};
    margin-top: 16px;
    margin-bottom: 8px;
`;

export const FormField = styled(Field)`
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const ButtonGroup = styled(ButtonBar)`
    margin-top: 32px;
    margin-bottom: 16px;
    text-align: right;
`;
